<template>
    <div class="flex pt-4 align-items-center qualification_steps_navigation_content__container column-gap-4">
        <i class="pi pi-angle-left text-sm font-semibold" :class="callbackPrev ? 'text-primary cursor-pointer' : 'secondary'" @click="onClickPrev"></i>
        <div class="flex flex-column relative">
            <div class="font-semibold py-1 px-2">
                <span class="text-primary text-sm">{{ numberZeroPrefix(currentStep) }}</span> / <span class="text-sm">{{ numberZeroPrefix(totalSteps) }}</span>
            </div>
            <ProgressBar
                :value="getProgress"
                :showValue="false"
                :pt="{root: {class: 'qualification_steps_navigation_content__progress'}}"
            />
        </div>
        <i class="pi pi-angle-right text-sm font-semibold" :class="callbackNext ? 'text-primary cursor-pointer' : 'secondary'" @click="onClickNext"></i>
    </div>
</template>

<script>
import {FormatHelper} from "../../../helpers/FormatHelper";
import ProgressBar from 'primevue/progressbar';

export default {
    name: "QualificationStepsNavigationContent",
    props: {
        callbackNext: {
            type: Function,
            required: false,
        },
        callbackPrev: {
            type: Function,
            required: false,
        }
    },
    data() {
        return {
            currentStep: 1,
            totalSteps: 0,
        }
    },
    mounted() {
        this.currentStep = this.$parent.index + 1;
        this.totalSteps = this.$parent.$parent.stepperpanels.length;
    },
    computed: {
        getProgress() {
            return 100 - (this.totalSteps - this.currentStep) / this.totalSteps * 100;
        },
    },
    methods: {
        numberZeroPrefix(number) {
            return FormatHelper.numberZeroPrefix(number);
        },
        onClickPrev() {
            if (this.callbackPrev) {
                this.callbackPrev();
            }
        },
        onClickNext() {
            if (this.callbackNext) {
                this.callbackNext();
            }
        }
    },
    components: {
        ProgressBar,
    }
}
</script>

<style scoped>
.qualification_steps_navigation_content__progress {
    height: 2px;
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #CED4DA;
}
</style>
